/**
 * Racine de l'application : routeur et garde d'accès.
 *
 * Toutes les routes authentifiées sont enveloppées par `GardeAdmin`, qui redirige vers
 * `/connexion` sans jeton. Les écrans rendent eux-mêmes la coquille (navigation, en-tête), parce
 * que chacun a son titre et son sous-titre.
 */
import { Navigate, Route, Routes } from 'react-router-dom';

import { GardeAdmin } from './garde-admin';
import { EcranAudit } from '../ecrans/audit';
import { EcranCarteEdition } from '../ecrans/carte-edition';
import { EcranCartes } from '../ecrans/cartes';
import { EcranConnexion } from '../ecrans/connexion';
import { EcranEquilibrage } from '../ecrans/equilibrage';
import { EcranIntrouvable } from '../ecrans/introuvable';
import { EcranJoueurs } from '../ecrans/joueurs';
import { EcranNiveauEdition } from '../ecrans/niveau-edition';
import { EcranNiveaux } from '../ecrans/niveaux';
import { EcranPublication } from '../ecrans/publication';

import type { ReactElement } from 'react';

/** Enveloppe un écran dans la garde d'accès. */
function protege(ecran: ReactElement): ReactElement {
  return <GardeAdmin>{ecran}</GardeAdmin>;
}

export function App() {
  return (
    <Routes>
      <Route path="/connexion" element={<EcranConnexion />} />
      <Route path="/" element={<Navigate to="/cartes" replace />} />
      <Route path="/cartes" element={protege(<EcranCartes />)} />
      <Route path="/cartes/:id" element={protege(<EcranCarteEdition />)} />
      <Route path="/equilibrage" element={protege(<EcranEquilibrage />)} />
      <Route path="/niveaux" element={protege(<EcranNiveaux />)} />
      <Route path="/niveaux/:id" element={protege(<EcranNiveauEdition />)} />
      <Route path="/publication" element={protege(<EcranPublication />)} />
      <Route path="/joueurs" element={protege(<EcranJoueurs />)} />
      <Route path="/audit" element={protege(<EcranAudit />)} />
      <Route path="*" element={<EcranIntrouvable />} />
    </Routes>
  );
}
